module.exports = __webpack_public_path__ + "static/img/khk001-1.011c5e83.jpg";